export function polyfillRandomUUID(logger: () => void): void {
  if (!crypto.randomUUID) {
    crypto.randomUUID = () => {
      const template = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
      const randomValues = new Uint8Array(16);
      crypto.getRandomValues(randomValues);

      return template.replace(/[xy]/g, (c, i) => {
        const r = (randomValues[i % 16] as number) >> (c === 'x' ? 0 : 4);
        const v = c === 'x' ? r & 0xf : (r & 0x3) | 0x8;
        return v.toString(16);
      }) as `${string}-${string}-${string}-${string}-${string}`;
    };

    logger();
  }
}
